import { BaseService } from './core/BaseService';

/** 举报提交结果（POST /api/works/{id}/report 契约，方案 3.4 C 端举报入口） */
export interface WorkReportResult {
  ok: boolean;
  /** 同一用户对同一作品已有待处理举报（幂等收口，前端提示无需重复提交） */
  duplicate: boolean;
}

class WorksApiService extends BaseService {
  /** 举报作品（JWT 鉴权）：落运维平台举报工单，reasonType ∈ violation/copyright/spam/other */
  async reportWork(workId: string, reasonType: string, reasonDetail = ''): Promise<WorkReportResult> {
    return this.post<WorkReportResult>(`/api/works/${encodeURIComponent(workId)}/report`, {
      reasonType,
      reasonDetail,
    });
  }
}

export const worksApi = new WorksApiService();
